import { render, staticRenderFns } from "./Help_Center.vue?vue&type=template&id=49b16898&scoped=true"
import script from "./Help_Center.vue?vue&type=script&lang=js"
export * from "./Help_Center.vue?vue&type=script&lang=js"
import style0 from "./Help_Center.vue?vue&type=style&index=0&id=49b16898&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b16898",
  null
  
)

export default component.exports